import React from 'react';
import { Link } from 'react-router';
import { Dialog } from '@blueprintjs/core';
import moment from 'moment';
import {
  ThongTinNguoiDungDon,
  ThongTinDonVuViec,
  ThongTinCoQuanDaGiaiQuyet,
  ThongTinNguoiUyQuyen
} from 'modules/letter-information/letter-detail';
import {Text} from 'components/tt-forms/common';

class DetailReception extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: {},
      dataNguoiDungDon: [],
      loaiNguoiDungDon: '',
      dataNguoiDuocUyQuyen: {},
      listTepUyQuyen: [],
      listTepChungChiHanhNghe: [],
      loaiDon: '',
      loaiDonGiaTri: '',
      loaiDoiTuong: '',
      linhVuc: '',
      linhVucChiTiet: '',
      linhVucChiTietSub: '',
      listTaiLieuBangChung: [],
      noiDung: '',
      dataCoQuanDaGiaiQuyet: {},
      dataDoanDiCung: []
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.item) {
      this.setState({
        data: nextProps.item,
        loaiNguoiDungDon : nextProps.item.loaiNguoiDungDon ? nextProps.item.loaiNguoiDungDon : '',
        dataNguoiDungDon : nextProps.item.listNguoiDungDon ? nextProps.item.listNguoiDungDon : [],
        dataNguoiDuocUyQuyen : nextProps.item.coUyQuyen ? nextProps.item.nguoiDuocUyQuyen : [],
        loaiDon : nextProps.item.loaiDonText ? nextProps.item.loaiDonText : '',
        loaiDonGiaTri : nextProps.item.loaiDon ? nextProps.item.loaiDon : '',
        loaiDoiTuong : nextProps.item.loaiDoiTuongInfo ? nextProps.item.loaiDoiTuongInfo : '',
        linhVuc : nextProps.item.linhVucDonThuDon ? nextProps.item.linhVucDonThuDon.ten : '',
        linhVucChiTiet : (nextProps.item.linhVucDonThuDon && nextProps.item.linhVucDonThuChiTietDon) ? nextProps.item.linhVucDonThuChiTietDon.ten : '',
        linhVucChiTietSub : (nextProps.item.linhVucDonThuDon && nextProps.item.linhVucDonThuChiTietDon && nextProps.item.chiTietLinhVucDonThuChiTietDon) ? nextProps.item.chiTietLinhVucDonThuChiTietDon.ten : '',
        noiDung : nextProps.item.noiDung ? nextProps.item.noiDung : '',
        listTaiLieuBangChung : nextProps.item.listTaiLieuBangChung ? [...nextProps.item.listTaiLieuBangChung, ...nextProps.item.listTaiLieuBangChungLuatSu] : [],
        dataDoanDiCung : nextProps.item.loaiNguoiDungDon == 'DOAN_DONG_NGUOI' ? (nextProps.item.listDoanDiCung ? nextProps.item.listDoanDiCung : []) : [],
        dataCoQuanDaGiaiQuyet : (nextProps.item.coThongTinCoQuanDaGiaiQuyet && nextProps.item.coQuanDaGiaiQuyetDon) ? nextProps.item.coQuanDaGiaiQuyetDon : {}
      });
    }
  }

  handleOnClose() {
    this.props.onClose();
  }

  render() {
    return (

        <Dialog
          isOpen={this.props.isOpen}
          onClose={this.handleOnClose.bind(this)}
          title={this.props.title}
          className="handle-letter-dialog"
          >
          <div className="pt-dialog-body">
            <div id="page" className="panel-page document-detail-page">
              <div className="center-wrap">
                <div className="heading no-margin">
                  <h2 className="heading-title icon-detail">Thông tin chi tiết đơn thư/vụ việc</h2>
                </div>
                <div className="wrapper_box mt15 mb15">
                  <div className="box-items">
                    <div className="box-forward ">
                      <div className="container-box">
                        <div className="group-box">
                          <div className="items-form">
                            <div className="rows box-top">
                              <div className="col-6">
                                <label className="pt-label pt-inline">
                                  Ngày tiếp: <span className="info-document">{this.props.item.ngayTiepNhan ? moment(this.props.item.ngayTiepNhan).format('DD/MM/YYYY - HH:mm') : (this.props.item.ngayTiepDan ? moment(this.props.item.ngayTiepDan).format('DD/MM/YYYY - HH:mm') : '')}</span>
                                </label>
                              </div>
                              {/*
                              <div className="col-6">
                                <p className="pull-right reception-count">Lượt tiếp <span>{this.props.item.soLuotTiepStr}</span></p>
                              </div>*/}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <ThongTinNguoiDungDon
                    title="Thông tin người đứng đơn/Vụ việc"
                    parent={this.state}
                  />

                  {this.state.data.coUyQuyen ? (
                    <div className="box-items mt20 mb0">
                      <ThongTinNguoiUyQuyen
                        title="Thông tin người được ủy quyền"
                        parent={this.state}
                      />
                    </div>
                  ) : ''}
                  <div className="box-items mt20">
                    <ThongTinDonVuViec
                      title="Thông tin đơn/Vụ việc"
                      isOpen = {true}
                      parent = {this.state}
                    />
                  </div>
                  {
                    this.state.data.coThongTinCoQuanDaGiaiQuyet ?
                      <div className="box-items">
                        <ThongTinCoQuanDaGiaiQuyet
                          title="Thông tin cơ quan đã giải quyết"
                          isOpen={true}
                          parent={this.state}
                        />
                      </div>
                    : ''
                  }
                  {
                    this.state.data.trangThaiYeuCauGapLanhDao ?
                      <div className="box-items pl10 pr10">
                        <div className="title">
                          <div className="rows">
                            <div className="col-12">
                              <h3>Ý kiến lãnh đạo</h3>
                            </div>
                          </div>
                        </div>
                        <div className="items-form">
                          <div className="rows">
                            <Text
                              className="col-input"
                              label="Thời gian:"
                              value={this.state.data.ngayTao ? moment(this.state.data.ngayTao).format('DD/MM/YYYY') : ''} />

                            <Text
                              className="col-input"
                              label="Ý kiến lãnh đạo:"
                              value={this.state.data.trangThaiYeuCauGapLanhDaoInfo ? this.state.data.trangThaiYeuCauGapLanhDaoInfo.ten : ''} />

                            <Text
                              className="col-100 mt10"
                              label="Lý do:"
                              value={this.state.data.lyDoThayDoiTTYeuCauGapLanhDao || ''} />

                          </div>
                        </div>
                      </div>
                    :''
                  }
                </div>
              </div>
            </div>
          </div>
          <div className="box-bottom">
            <Link onClick={this.handleOnClose.bind(this)} className="btn-action btn-close">
              <span>Đóng</span>
            </Link>
          </div>
        </Dialog>

    );
  }
}


export default DetailReception;



// WEBPACK FOOTER //
// ./src/components/modules/reception-periodical/popup-detail/DetailReception.jsx